import React, { Component } from 'react';
import { Layout, Menu, Icon, Button, Descriptions, Select} from 'antd';

const { Header, Content, Footer, Sider } = Layout;

const { Option } = Select;

class ReviewImagesMobile extends Component {

  handleChange = async(e, img) => {
    this.props.updateImage(e, img)
  }

  render() {
    return (
      <div>
        <h2>Review Predictions</h2>

        <div style={{ marginTop: 10, marginBottom: 20, padding: 24, background: '#fff', display: 'flex', flexDirection: 'column'}}> 
          {this.props.imgArray.map((img, i) => {
            return (
              <div key={i} style={{marginTop: 10, marginBottom: 10}} >    
                <div>
                  <Select 
                    defaultValue={img.linkInfo.classifiedData.updatedWinner ? img.linkInfo.classifiedData.updatedWinner : img.linkInfo.classifiedData.winningClass.label} 
                    style={{ width: 120, marginBottom: 12 }} 
                    onChange={(e) => this.handleChange(e, img)}
                  >                          
                    <Option value="career_page">Career Page</Option>
                    <Option value="jobPostingDetail">Job Posting Detail</Option>
                    <Option value="list_of_jobs">List of Jobs</Option>
                    <Option value="webpage">Webpage</Option>        
                  </Select>
                  <p>company: {img.linkInfo && img.linkInfo.companyName}</p>
                  <p>score {img.linkInfo.classifiedData && img.linkInfo.classifiedData.winningClass.prob}</p>
                </div>
                <img style={{ maxWidth: '100%' }} src={img.src2} />
              </div>
            )
          })}
        </div>
      </div>
    );
  }
}

export default ReviewImagesMobile;